import service from '../service.js'

export default {
    /**
     * 管理员登录
     * @returns 
     */
    getLogin: (params) => {
        return service({
            url: '/Login/AdminLogin',
            method: 'post',
            data: params
        })
    }
}